import React, { ReactNode } from "react";
import { Button, Flex, FlexProps, Text } from "@chakra-ui/react";
import CustomIcon, { AssetTypes } from "../../../public/icons-v1_1";

interface PageHeaderProps extends FlexProps {
  iconName?: AssetTypes;
  title?: string;
  onIconClick?: () => void;
  iconSize?: number;
  iconColor?: string;
  color?: string;
  actions?: ReactNode;
  children?: ReactNode;
}

function PageHeader({
  iconName,
  iconSize = 28,
  iconColor = "#8F8F8C",
  title,
  color = "#444444",
  onIconClick,
  actions,
  children,
  textStyle,
  ...props
}: PageHeaderProps) {
  return (
    <Flex
      padding={"4px 16px"}
      background={"#FFFFFF"}
      boxShadow={"inset 0 -0.5px 0 0 #D4D4D1"}
      justifyContent={"space-between"}
      alignItems={"center"}
      {...props}
    >
      <Flex alignItems={"center"}>
        {iconName && (
          <Button
            variant={"ghost"}
            padding={"6px"}
            onClick={onIconClick}
            _hover={{
              background: "inherit",
              "& svg": {
                color: "#1272EF",
              },
            }}
            _active={{
              "& svg": {
                color: "#00417D",
              },
            }}
          >
            <CustomIcon
              src={iconName}
              width={iconSize}
              height={iconSize}
              color={iconColor}
            />
          </Button>
        )}
        {children ? (
          children
        ) : (
          <Text textStyle={textStyle ?? "body-lg-bold"} color={color}>
            {title}
          </Text>
        )}
      </Flex>
      {actions && <Flex gap={"8px"}>{actions}</Flex>}
    </Flex>
  );
}

export default PageHeader;
